import { ComponentType } from 'react';

export const PRODUCT_LINK_VARIANTS = {
  EXTERNAL: 'extenral',
  INTERNAL: 'internal',
} as const;

export type ProductLinkVariant =
  (typeof PRODUCT_LINK_VARIANTS)[keyof typeof PRODUCT_LINK_VARIANTS];

export type ProductLinkType = {
  label: string;
  url?: string;
  isVisible?: boolean | string | null;
  variant: ProductLinkVariant;
  icon?: ComponentType<{ [prop: string]: unknown }>;
};

export const BREAKPOINTS = {
  SMALL: '@media (max-width: 1279px)',
};
